import { motion } from "framer-motion";
import { PenTool, MapPin, Zap, CalendarCheck, Fingerprint } from "lucide-react";

const services = [
  {
    icon: PenTool,
    title: "Bespoke Trade Web Design",
    desc: "Custom-built websites for contractors, roofers, and home service pros — designed to look like the quality of your work, not a template.",
    span: "lg:col-span-2",
  },
  {
    icon: MapPin,
    title: "Local SEO Dominance",
    desc: "Rank in your service area when customers search. Google Business optimization, location pages, and review integration.",
    span: "",
  },
  {
    icon: Zap,
    title: "High-Speed Lead Funnels",
    desc: "Sub-second load times and conversion-focused layouts that turn visitors into phone calls and quote requests.",
    span: "",
  },
  {
    icon: CalendarCheck,
    title: "Automated Quote Booking",
    desc: "Intake forms engineered for the trades — job type, photos, service area, and instant notifications to your phone.",
    span: "",
  },
  {
    icon: Fingerprint,
    title: "Brand Monogram Identity",
    desc: "A luxury-grade logo and identity system that makes a two-truck operation look like a market leader.",
    span: "lg:col-span-2",
  },
];

const container = { hidden: {}, show: { transition: { staggerChildren: 0.1 } } };
const item = {
  hidden: { opacity: 0, y: 32 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } },
};

export default function Services() {
  return (
    <section id="services" data-testid="agency-services-section" className="py-28 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-16"
        >
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-gold/80 mb-4">What We Craft</p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-[#F8F6F0] tracking-tight max-w-2xl">
            Everything a trade business needs to <span className="gold-text italic">win online.</span>
          </h2>
        </motion.div>

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5"
        >
          {services.map((s) => (
            <motion.div
              key={s.title}
              variants={item}
              data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className={`spotlight-card group rounded-2xl border gold-border-subtle bg-surface/60 p-8 lg:p-10 hover:border-gold/40 transition-colors duration-500 ${s.span}`}
            >
              <div className="w-12 h-12 rounded-xl border border-gold/25 flex items-center justify-center mb-6 group-hover:bg-gold/10 transition-colors duration-500">
                <s.icon size={22} className="text-gold" strokeWidth={1.5} />
              </div>
              <h3 className="font-serif text-2xl text-[#F8F6F0] mb-3">{s.title}</h3>
              <p className="text-sm text-zinc-400 leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
